/* Rooana — Hero PDP behaviour (13.10.2026): reveal, counters, timeline, lazy video, scrollers, CTA. */
(function () {
  if (window.RooanaHero) return;
  var root = document.documentElement;
  root.classList.add('rh-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.rh-reveal:not(.is-in)');
    if (!hasIO || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    els.forEach(function (e) { io.observe(e); });
  }

  function format(n, decimals) {
    return n.toLocaleString('bg-BG', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  }

  function counters(scope) {
    (scope || document).querySelectorAll('[data-rh-count]:not([data-rh-done])').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-rh-count'));
      var dec = parseInt(el.getAttribute('data-rh-decimals') || '0', 10);
      if (isNaN(target)) return;
      el.setAttribute('data-rh-done', '1');
      function run() {
        if (reduce) { el.textContent = format(target, dec); return; }
        var start = null, dur = 1500;
        function step(t) {
          if (!start) start = t;
          var p = Math.min(1, (t - start) / dur);
          el.textContent = format(target * (1 - Math.pow(1 - p, 3)), dec);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      if (!hasIO) { run(); return; }
      el.textContent = format(0, dec);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { run(); io.disconnect(); } });
      }, { threshold: 0.5 });
      io.observe(el);
    });
  }

  var timelines = [];
  function updateTimelines() {
    var vh = window.innerHeight;
    timelines.forEach(function (tl) {
      var r = tl.el.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) return;
      var line = vh * 0.62;
      var p = Math.max(0, Math.min(1, (line - r.top) / Math.max(1, r.height)));
      if (tl.fill) tl.fill.style.height = (p * 100).toFixed(2) + '%';
      tl.items.forEach(function (it) {
        it.classList.toggle('is-on', it.getBoundingClientRect().top + 14 <= line);
      });
    });
  }
  function initTimelines(scope) {
    (scope || document).querySelectorAll('[data-rh-tl]').forEach(function (el) {
      if (el.dataset.rhTlInit) return;
      el.dataset.rhTlInit = '1';
      timelines.push({ el: el, fill: el.querySelector('.rh-tl__fill'), items: el.querySelectorAll('.rh-tl__item') });
    });
    updateTimelines();
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking || !timelines.length) return;
    ticking = true;
    requestAnimationFrame(function () { updateTimelines(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', updateTimelines);

  function videos(scope) {
    (scope || document).querySelectorAll('[data-rh-video]').forEach(function (wrap) {
      if (wrap.dataset.rhInit) return;
      wrap.dataset.rhInit = '1';
      var v = wrap.querySelector('video');
      var btn = wrap.querySelector('[data-rh-play]');
      if (!v) return;
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var saveData = navigator.connection && navigator.connection.saveData;
      var auto = wrap.dataset.autoplay === 'true' && !reduce && !saveData && !(mobile && wrap.dataset.autoplayMobile !== 'true');
      var userPaused = false;
      v.addEventListener('playing', function () { wrap.classList.add('is-playing'); });
      v.addEventListener('pause', function () { wrap.classList.remove('is-playing'); });
      function load() { if (!v.getAttribute('src') && v.dataset.src) v.setAttribute('src', v.dataset.src); }
      function play() {
        load();
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      if (btn) btn.addEventListener('click', function () {
        if (!v.paused) { userPaused = true; v.pause(); }
        else { userPaused = false; play(); }
      });
      v.addEventListener('click', function () { if (!v.paused) { userPaused = true; v.pause(); } });
      if (hasIO) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { if (auto && !userPaused) play(); }
            else if (!v.paused) v.pause();
          });
        }, { threshold: 0.35 });
        io.observe(wrap);
      } else if (auto) { play(); }
    });
  }

  function scrollers(scope) {
    (scope || document).querySelectorAll('[data-rh-scroller-nav]').forEach(function (nav) {
      if (nav.dataset.rhInit) return;
      nav.dataset.rhInit = '1';
      var track = document.getElementById(nav.getAttribute('data-rh-scroller-nav'));
      if (!track) return;
      nav.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var item = track.firstElementChild;
          var step = item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
          track.scrollBy({ left: parseInt(b.getAttribute('data-dir'), 10) * step, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  function ctas(scope) {
    (scope || document).querySelectorAll('[data-rh-buy]').forEach(function (btn) {
      if (btn.dataset.rhInit) return;
      btn.dataset.rhInit = '1';
      btn.addEventListener('click', function (ev) {
        var real = document.querySelector('product-form form button[name="add"]');
        if (real && !real.disabled) { ev.preventDefault(); real.click(); }
      });
    });
  }

  function init(scope) { reveal(scope); counters(scope); initTimelines(scope); videos(scope); scrollers(scope); ctas(scope); }
  window.RooanaHero = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();